"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCrops = void 0;
const routes_1 = require("../../routes");
const getCrops = (client) => async (query) => {
    const response = await client.get(routes_1.ENDPOINTS.GET_CROPS.path, {
        params: query,
    });
    return response.data;
};
exports.getCrops = getCrops;
